// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Baloo+2&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Properties (converted from SCSS variables) */
:root {
    --main-green: #79dd09;
    --main-green-rgb-015: rgba(121, 221, 9, 0.1);
    --main-yellow: #bdbb49;
    --main-yellow-rgb-015: rgba(189, 187, 73, 0.1);
    --main-red: #bd150b;
    --main-red-rgb-015: rgba(189, 21, 11, 0.1);
    --main-blue: #0076bd;
    --main-blue-rgb-015: rgba(0, 118, 189, 0.1);
}


.container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between; /* This will space your cards nicely */
    gap: 20px; /* Adjust the gap between cards as needed */
  }

/* 
body {
    font-family: "Baloo 2", cursive;
    font-size: 16px;
    color: #ffffff;
    text-rendering: optimizeLegibility;
    font-weight: initial;
} */

.caseStudyMain{
    font-family: "Baloo 2", cursive;
    font-size: 16px;
    color: #ffffff;
    text-rendering: optimizeLegibility;
    font-weight: initial;
    
}

.dark {
    background: #110f16;
}

.light {
    background: #f3f5f7;
}

a, a:hover {
    text-decoration: none;
    transition: color 0.3s ease-in-out;
}

#pageHeaderTitle {
    margin: 2rem 0;
    text-transform: uppercase;
    text-align: center;
    font-size: 2.5rem;
   
}

/* Cards */
.postcard {
    display: flex;
    box-shadow: 0 4px 21px -12px rgba(0, 0, 0, 0.66);
    border-radius: 10px;
    margin: 0 0 2rem 0;
    overflow: hidden;
    position: relative;
    color: #ffffff;
    background-color: inherit; /* Set to inherit to respect .dark and .light classes */
    width: 100%; /* Adjust the width as needed */
    cursor: pointer;
}

.basix{
    flex-basis: calc(50% - 10px);
    width:"50%";
}

.postcard.dark {
    background-color: #18151f;
}

.postcard.light {
    background-color: #e1e5ea;
}

.postcard .t-dark {
    color: #18151f;
}

.postcard a {
    color: inherit;
}

.postcard h1,
.postcard .h1 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}

.postcard .small {
    font-size: 80%;
    color: #b37b7b;
    font-family: "FS sinclair medium";
}

.postcard .postcard__title {
    font-size: 1.75rem;
    color: rgb(172, 38, 59);
    font-family: FS Sinclair;
  }
  .postcard .postcard__img {
    width: 50%; /* Image takes up half the card */
    object-fit: fill; /* Cover the entire area */
}
  .postcard .postcard__img_link {
    display: contents;
  }
  
  .postcard .postcard__bar {
    width: 50px;
    height: 10px;
    margin: 10px 0;
    border-radius: 5px;
    background-color: #8d1b1b;
    transition: width 0.2s ease;
  }
  

  .postcard .postcard__text {
    padding: 1.5rem;
    width: 50%; /* Text takes up the other half */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Space the items nicely */
}

  .postcard .postcard__preview-txt {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    height: 100%;
    font-family: "Apercu light";
    color: #212529; 
  }
  
  .postcard .postcard__tagbox {
    display: flex;
    flex-flow: row wrap;
    font-size: 14px;
    margin: 20px 0 0 0;
    padding: 0;
    justify-content: center;
  }
  
  .postcard .postcard__tagbox .tag__item {
    display: inline-block;
    background: rgba(83, 83, 83, 0.4);
    border-radius: 3px;
    padding: 2.5px 10px;
    margin: 0 5px 5px 0;
    cursor: default;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.3s;
  }
  
  .postcard .postcard__tagbox .tag__item:hover {
    background: rgba(83, 83, 83, 0.8);
  }
  
  .postcard:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* background-image: linear-gradient(-70deg, 
    #a6dfd8, transparent 60%); */
    opacity: 1;
    border-radius: 10px;
  }
  
  .postcard:hover .postcard__bar {
    width: 100px;
  }
  
  /* COLORS */
  .postcard.green .postcard__tagbox .play:hover,
  .postcard.yellow .postcard__tagbox .play:hover {
    background: var(--main-green);
    color: black;
  }
  
  .postcard.green .postcard__title:hover,
  .postcard.yellow .postcard__title:hover {
    color: var(--main-green);
  }
  
  .postcard.green .postcard__bar,
  .postcard.yellow .postcard__bar {
    background-color: var(--main-green);
  }
  
  .postcard.green::before,
  .postcard.yellow::before {
    background-image: linear-gradient(-30deg, var(--main-green-rgb-015), transparent 50%);
  }
  
  .postcard.green:nth-child(2n)::before,
  .postcard.yellow:nth-child(2n)::before {
    background-image: linear-gradient(30deg, var(--main-green-rgb-015), transparent 50%);
  }

  .postcard__tagbox .tag__item a {
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
    cursor: pointer; /* Changes the cursor to signify this is a clickable link */
  }
  
  .postcard__tagbox .tag__item a:hover {
    background-color: #0056b3; /* Change to your preferred hover color */
    color: white; /* Change text color to contrast the background if needed */
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
    }
    .postcard {
      flex-direction: column;
      width: 100%; /* Make cards stack vertically on smaller screens */
    }
    .postcard .postcard__img {
      width: 100%; /* Adjust image and text block to fill the card */
    }
    .postcard .postcard__text {
      width: 100%;
    }
    .caseStudyMain {
      font-size: 14px; /* Reduce font size for smaller devices */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/caseStudies/CaseStudyMain.css"],"names":[],"mappings":"AAGA,sDAAsD;AACtD;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,sBAAsB;IACtB,8CAA8C;IAC9C,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,2CAA2C;AAC/C;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B,EAAE,sCAAsC;IACtE,SAAS,EAAE,2CAA2C;EACxD;;AAEF;;;;;;;GAOG;;AAEH;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,oBAAoB;;AAExB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA,UAAU;AACV;IACI,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB,EAAE,uDAAuD;IAClF,WAAW,EAAE,+BAA+B;IAC5C,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,UAAU,EAAE,iCAAiC;IAC7C,gBAAgB,EAAE,0BAA0B;AAChD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;EAC7B;;;EAGA;IACE,eAAe;IACf,UAAU,EAAE,iCAAiC;IAC7C,aAAa;IACb,sBAAsB;IACtB,8BAA8B,EAAE,2BAA2B;AAC/D;;EAEE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP;gCAC4B;IAC5B,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA,WAAW;EACX;;IAEE,6BAA6B;IAC7B,YAAY;EACd;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;;IAEE,qFAAqF;EACvF;;EAEA;;IAEE,oFAAoF;EACtF;;EAEA;IACE,sCAAsC,EAAE,uCAAuC;IAC/E,eAAe,EAAE,2DAA2D;EAC9E;;EAEA;IACE,yBAAyB,EAAE,yCAAyC;IACpE,YAAY,EAAE,2DAA2D;EAC3E;;EAEA;IACE;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;MACtB,WAAW,EAAE,mDAAmD;IAClE;IACA;MACE,WAAW,EAAE,iDAAiD;IAChE;IACA;MACE,WAAW;IACb;IACA;MACE,eAAe,EAAE,yCAAyC;IAC5D;EACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Baloo+2&display=swap\");\r\n\r\n\r\n/* Custom Properties (converted from SCSS variables) */\r\n:root {\r\n    --main-green: #79dd09;\r\n    --main-green-rgb-015: rgba(121, 221, 9, 0.1);\r\n    --main-yellow: #bdbb49;\r\n    --main-yellow-rgb-015: rgba(189, 187, 73, 0.1);\r\n    --main-red: #bd150b;\r\n    --main-red-rgb-015: rgba(189, 21, 11, 0.1);\r\n    --main-blue: #0076bd;\r\n    --main-blue-rgb-015: rgba(0, 118, 189, 0.1);\r\n}\r\n\r\n\r\n.container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between; /* This will space your cards nicely */\r\n    gap: 20px; /* Adjust the gap between cards as needed */\r\n  }\r\n\r\n/* \r\nbody {\r\n    font-family: \"Baloo 2\", cursive;\r\n    font-size: 16px;\r\n    color: #ffffff;\r\n    text-rendering: optimizeLegibility;\r\n    font-weight: initial;\r\n} */\r\n\r\n.caseStudyMain{\r\n    font-family: \"Baloo 2\", cursive;\r\n    font-size: 16px;\r\n    color: #ffffff;\r\n    text-rendering: optimizeLegibility;\r\n    font-weight: initial;\r\n    \r\n}\r\n\r\n.dark {\r\n    background: #110f16;\r\n}\r\n\r\n.light {\r\n    background: #f3f5f7;\r\n}\r\n\r\na, a:hover {\r\n    text-decoration: none;\r\n    transition: color 0.3s ease-in-out;\r\n}\r\n\r\n#pageHeaderTitle {\r\n    margin: 2rem 0;\r\n    text-transform: uppercase;\r\n    text-align: center;\r\n    font-size: 2.5rem;\r\n   \r\n}\r\n\r\n/* Cards */\r\n.postcard {\r\n    display: flex;\r\n    box-shadow: 0 4px 21px -12px rgba(0, 0, 0, 0.66);\r\n    border-radius: 10px;\r\n    margin: 0 0 2rem 0;\r\n    overflow: hidden;\r\n    position: relative;\r\n    color: #ffffff;\r\n    background-color: inherit; /* Set to inherit to respect .dark and .light classes */\r\n    width: 100%; /* Adjust the width as needed */\r\n    cursor: pointer;\r\n}\r\n\r\n.basix{\r\n    flex-basis: calc(50% - 10px);\r\n    width:\"50%\";\r\n}\r\n\r\n.postcard.dark {\r\n    background-color: #18151f;\r\n}\r\n\r\n.postcard.light {\r\n    background-color: #e1e5ea;\r\n}\r\n\r\n.postcard .t-dark {\r\n    color: #18151f;\r\n}\r\n\r\n.postcard a {\r\n    color: inherit;\r\n}\r\n\r\n.postcard h1,\r\n.postcard .h1 {\r\n    margin-bottom: 0.5rem;\r\n    font-weight: 500;\r\n    line-height: 1.2;\r\n}\r\n\r\n.postcard .small {\r\n    font-size: 80%;\r\n    color: #b37b7b;\r\n    font-family: \"FS sinclair medium\";\r\n}\r\n\r\n.postcard .postcard__title {\r\n    font-size: 1.75rem;\r\n    color: rgb(172, 38, 59);\r\n    font-family: FS Sinclair;\r\n  }\r\n  .postcard .postcard__img {\r\n    width: 50%; /* Image takes up half the card */\r\n    object-fit: fill; /* Cover the entire area */\r\n}\r\n  .postcard .postcard__img_link {\r\n    display: contents;\r\n  }\r\n  \r\n  .postcard .postcard__bar {\r\n    width: 50px;\r\n    height: 10px;\r\n    margin: 10px 0;\r\n    border-radius: 5px;\r\n    background-color: #8d1b1b;\r\n    transition: width 0.2s ease;\r\n  }\r\n  \r\n\r\n  .postcard .postcard__text {\r\n    padding: 1.5rem;\r\n    width: 50%; /* Text takes up the other half */\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between; /* Space the items nicely */\r\n}\r\n\r\n  .postcard .postcard__preview-txt {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n    height: 100%;\r\n    font-family: \"Apercu light\";\r\n    color: #212529; \r\n  }\r\n  \r\n  .postcard .postcard__tagbox {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    font-size: 14px;\r\n    margin: 20px 0 0 0;\r\n    padding: 0;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .postcard .postcard__tagbox .tag__item {\r\n    display: inline-block;\r\n    background: rgba(83, 83, 83, 0.4);\r\n    border-radius: 3px;\r\n    padding: 2.5px 10px;\r\n    margin: 0 5px 5px 0;\r\n    cursor: default;\r\n    user-select: none;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .postcard .postcard__tagbox .tag__item:hover {\r\n    background: rgba(83, 83, 83, 0.8);\r\n  }\r\n  \r\n  .postcard:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    /* background-image: linear-gradient(-70deg, \r\n    #a6dfd8, transparent 60%); */\r\n    opacity: 1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .postcard:hover .postcard__bar {\r\n    width: 100px;\r\n  }\r\n  \r\n  /* COLORS */\r\n  .postcard.green .postcard__tagbox .play:hover,\r\n  .postcard.yellow .postcard__tagbox .play:hover {\r\n    background: var(--main-green);\r\n    color: black;\r\n  }\r\n  \r\n  .postcard.green .postcard__title:hover,\r\n  .postcard.yellow .postcard__title:hover {\r\n    color: var(--main-green);\r\n  }\r\n  \r\n  .postcard.green .postcard__bar,\r\n  .postcard.yellow .postcard__bar {\r\n    background-color: var(--main-green);\r\n  }\r\n  \r\n  .postcard.green::before,\r\n  .postcard.yellow::before {\r\n    background-image: linear-gradient(-30deg, var(--main-green-rgb-015), transparent 50%);\r\n  }\r\n  \r\n  .postcard.green:nth-child(2n)::before,\r\n  .postcard.yellow:nth-child(2n)::before {\r\n    background-image: linear-gradient(30deg, var(--main-green-rgb-015), transparent 50%);\r\n  }\r\n\r\n  .postcard__tagbox .tag__item a {\r\n    transition: background-color 0.3s ease; /* Smooth transition for hover effect */\r\n    cursor: pointer; /* Changes the cursor to signify this is a clickable link */\r\n  }\r\n  \r\n  .postcard__tagbox .tag__item a:hover {\r\n    background-color: #0056b3; /* Change to your preferred hover color */\r\n    color: white; /* Change text color to contrast the background if needed */\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .container {\r\n      flex-direction: column;\r\n    }\r\n    .postcard {\r\n      flex-direction: column;\r\n      width: 100%; /* Make cards stack vertically on smaller screens */\r\n    }\r\n    .postcard .postcard__img {\r\n      width: 100%; /* Adjust image and text block to fill the card */\r\n    }\r\n    .postcard .postcard__text {\r\n      width: 100%;\r\n    }\r\n    .caseStudyMain {\r\n      font-size: 14px; /* Reduce font size for smaller devices */\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
